module.exports = __webpack_public_path__ + "assets/0a0e3775.wav";